module.exports = __webpack_public_path__ + "static/parade-2019-house04-4343b94f888a5aa286a8ad7882bac88a.jpg";